module.exports = __webpack_public_path__ + "static/media/cash-for-used-car2.4839150d.png";